<script lang="ts">
  import { getAppConfig } from '../../../../../common/config/app-config';
  import { getStr } from '../../../../../common/util';
  import Icon from '../../../../common/components/Icon.svelte';

  export let accordion = false;
  export let place = 'expire-drop-down';
  const { joodExpiredFlag, extraThemeResourcePath, encodedContextPath, pageId } = getAppConfig();
  const joodTypeArray = {
    BASIC: 'blue',
    VIP: 'gold',
    SMART: 'smart',
  };

  let messageText = `extra.jood.renew.${joodTypeArray[joodExpiredFlag]}`;
  if (accordion) {
    messageText = `extra.jood.renew.${joodTypeArray[joodExpiredFlag]}.perks`;
  }
  if (pageId !== 'productDetails' && joodExpiredFlag === 'SMART') {
    messageText = 'extra.jood.wallet.jood.renew.link.smart.all';
  }
</script>

{#if joodExpiredFlag}
  <div class="subscribe-upgrade-bottom">
    <div class="c_expirecard pdp-card {place}">
      <div class="c_infoicon">
        <img
          src="{extraThemeResourcePath}/images/jood/expired/info-icon.svg"
          class="joodInfoIcon checkoutPriceCard"
          alt="Jood"
        />
      </div>
      <div
        class="expired-text-container expired-text-{joodExpiredFlag}"
        class:isPLP={pageId === 'search' || pageId === 'productList'}
      >
        <span class="expired-text">{getStr('extra.jood.expired')}</span>
        <button
          on:click|stopPropagation|preventDefault={_e =>
            (window.location.href = `${encodedContextPath}/jood/benefits/`)}
          class="renewal-link">{getStr(messageText)} <Icon type="font" glyph="chevron_right" mobileSize={12} /></button
        >
      </div>
    </div>
  </div>
{/if}

<style lang="scss">
  @import '../../../../common/styles/colors.new.scss';

  :global {
    .jood-savings-accordion {
      .subscribe-upgrade-bottom {
        background: transparent !important;
      }
      &.jood-dropdown.open {
        // padding-bottom: 40px !important;
        .c_expirecard {
          bottom: 0;
          padding-bottom: 12px;
          position: absolute;
        }
      }
    }
  }
  .subscribe-upgrade-bottom {
    // background: $primary-white;
    text-align: center;
    border-radius: 0px 0px 11px 11px;
    @include responsive {
      padding: 2px;
    }
  }
  :global(.variant-plp-list),
  :global(.variant-pdp) {
    .subscribe-upgrade-bottom {
      padding: 0 0 8px 12px;
    }
    .expired-text-container {
      &.expired-text-VIP,
      &.expired-text-SMART,
      &.expired-text-BASIC {
        @include responsive {
          font-size: 10px;
        }
        .renewal-link {
          @include responsive {
            gap: 0px;
          }
        }
      }
    }
  }
  :global {
    .c_productDetails {
      .jood-day-banner-new.expired-card {
        .subscribe-upgrade-bottom {
          background: $primary-white;
          padding: 5px 10px;
        }
      }
    }
  }
</style>
